import classNames from 'classnames';
import React, {useEffect, useRef, useState} from 'react';
import CustomAudioPlayer from '../../../../../components/mazraeKit/customAudioPlayer';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import {addDotTostring} from '../../../../../utilities/helper/textConvertor';
import {IChatReplyState} from '../../type';
import useOnClickOutside from '../../../../../utilities/hooks/useOutsideClick';

import './style.css';
import {IIsDeleteChat} from '../..';
import {useParams} from 'react-router-dom';

interface MessageProps {
  is_author: boolean;
  text: string;
  created_at?: string;
  is_seen: boolean;
  guid: string;
  currentVideoPlaying?: string;
  replyingChat?: IChatReplyState;
  chat: IMessagesChatsResults;
  isDeleteChat: IIsDeleteChat;
  setIsDeleteChat: React.Dispatch<React.SetStateAction<IIsDeleteChat>>;
  setReplyingChat: React.Dispatch<
    React.SetStateAction<IChatReplyState | undefined>
  >;
  setcurrentVideoPlaying: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  refresh: () => void;
  setParentChatGuid: React.Dispatch<React.SetStateAction<string>>;
}
const Message = ({
  text,
  is_author,
  created_at,
  is_seen,
  currentVideoPlaying,
  guid,
  replyingChat,
  chat,
  setIsDeleteChat,
  refresh,
  setcurrentVideoPlaying,
  setReplyingChat,
  setParentChatGuid,
}: MessageProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const chatItemRef = useRef<HTMLDivElement>(null);
  const {guid: chatGuid} = useParams();
  const [holdTimer, setHoldTimer] = useState<NodeJS.Timeout | null>(null);

  const [isHolding, setIsHolding] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isOpenMore, setIsOpenMore] = useState(false);
  const vidoPlayer = useRef<HTMLVideoElement>(null);
  const playingHandler = () => {
    if (vidoPlayer.current) {
      if (isPlaying) {
        vidoPlayer.current.pause();
      } else {
        vidoPlayer.current.play();
      }
    }
  };

  useOnClickOutside(wrapperRef, () => setIsOpenMore(false), 'pointerdown');

  useEffect(() => {
    if (
      currentVideoPlaying &&
      vidoPlayer.current &&
      currentVideoPlaying !== guid
    ) {
      vidoPlayer.current.pause();
      setIsPlaying(false);
      vidoPlayer.current.currentTime = 0;
    }
  }, [currentVideoPlaying, vidoPlayer.current]);

  const onHoldHandler = () => {
    setIsHolding(true);
    const timer = setTimeout(() => {
      setIsOpenMore(prev => !prev);
    }, 500);

    setHoldTimer(timer);
  };
  const handlePointerUp = () => {
    setIsHolding(false);
    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
  };

  const handlePointerLeave = () => {
    setIsHolding(false);
    if (holdTimer) {
      clearTimeout(holdTimer);
      setHoldTimer(null);
    }
  };
  const downloadFile = () => {
    const link = document.createElement('a');

    link.href = chat.file_info?.url || '';
    link.setAttribute('download', 'download.txt');

    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(chat.file_info?.url || '');
  };

  // const {userChatDetailData, userChatDetailIsLoading} =
  //   useGetUserChatDetail(guid);

  return (
    <div
      key={guid}
      id={guid}
      ref={wrapperRef}
      className={classNames('flex flex-col gap-1 relative w-full', {
        'items-end': !is_author,
        'items-start': is_author,
      })}
      onPointerDown={() => onHoldHandler()}
      onPointerUp={handlePointerUp}
      onPointerLeave={handlePointerLeave}
    >
      <div
        id="chatBox"
        ref={chatItemRef}
        className={classNames(
          'min-w-fit max-w-[90%] col-span-1 flex flex-col p-1 gap-2 justify-center text-[18px] font-medium shadow-[0_4px_5px_rgba(171,190,209,0.3)]',
          'bar',
          {
            'bg-blue-200  rounded-r-lg rounded-bl-lg items-end ': isHolding,
            'bg-farm-shop-200 rounded-l-lg rounded-br-lg items-start text-text-chat-author':
              is_author && !isHolding,
            'bg-white rounded-r-lg rounded-bl-lg items-end text-black':
              !is_author && !isHolding,
            'min-w-[200px]': chat.parent,
          },
        )}
      >
        <div
          className={classNames(
            'absolute top-4 !z-50 reply-chat-custom-wrapper w-[190px]  shadow-xl py-2 pl-6 gap-2 pr-2 flex-col text-md font-Medium text-gray-900 bg-white ',
            {
              'right-9':
                chat?.parent?.message && chat?.parent?.message.length < 20,
              'left-9':
                chat?.parent?.message && chat?.parent?.message.length > 40,
              flex: isOpenMore,
              hidden: !isOpenMore,
            },
            {'left-9': chat?.file_info && chat?.file_info},
            {
              '!left-[-30px]':
                is_author &&
                chat?.message?.length < 150 &&
                chat?.message?.length >= 300,
              '!left-[-211px]':
                is_author &&
                chatItemRef?.current &&
                chatItemRef?.current?.offsetWidth < 150 &&
                !chat?.file_info,
            },
          )}
        >
          <div
            className="flex items-center gap-1"
            onClick={() => {
              setReplyingChat({
                fromReply: {
                  guid: chat.guid,
                  title: chat.message || chat.file_info?.type || '',
                },
              });
              setIsOpenMore(false);
            }}
          >
            <SpanIcon className="icon-Back text-xl" />
            <span>پاسخ</span>
          </div>
          {is_author && (
            <div
              className="flex items-center gap-1"
              onClick={() => {
                setIsDeleteChat({
                  isOpen: true,
                  data: {guid: chatGuid || '', chatItem: chat.guid || ''},
                });
              }}
            >
              <SpanIcon className="icon-nameDelete text-xl" />
              <span>حذف</span>
            </div>
          )}
        </div>
        {chat.parent && (
          <div
            onClick={() => setParentChatGuid(chat?.parent?.guid || '')}
            // href={`#${chat.parent.guid}`}
            className="no-underline flex items-center w-full min-w-[200px] gap-1 text-gray-950"
          >
            <SpanIcon className="icon-Back text-gray-700" />
            <div
              className={classNames(
                'w-fit h-[60px] overflow-hidden m-1.5 text-gray-950 text-md font-Regular bg-black bg-opacity-10 px-2 py-1 rounded-[8px]',
              )}
            >
              {addDotTostring(chat.parent.message, 20)}
            </div>
          </div>
        )}
        {chat.file_info && (
          <>
            {chat.file_info.type === 'image' && (
              <div
                className="flex w-full h-fit"
                // onPointerDown={() => onHoldHandler()}
                // onPointerUp={handlePointerUp}
                // onPointerLeave={handlePointerLeave}
              >
                <img
                  height={235}
                  className="rounded-[8px] w-full"
                  src={chat.file_info.url}
                  alt="profile"
                />
              </div>
            )}
            {chat.file_info.type === 'pdf' && (
              <div className="flex gap-1 w-full">
                <>
                  <div
                    className="flex w-full flex-col text-gray-950 items-end"
                    onClick={() => downloadFile()}
                    // onPointerDown={() => onHoldHandler()}
                    // onPointerUp={handlePointerUp}
                    // onPointerLeave={handlePointerLeave}
                  >
                    <span
                      className="text-md font-Medium line-clamp-1"
                      dir="ltr"
                    >
                      {chat.file_info?.name}
                    </span>
                    <span className="text-md font-Regular">
                      {(chat.file_info.size / 1024).toFixed(2)}
                    </span>
                  </div>{' '}
                  <div>
                    <img
                      width={40}
                      height={40}
                      className="w-[40px] h-[40px]"
                      src="https://s3.ir-thr-at1.arvanstorage.ir/my-chats/pdfIcon.svg"
                      alt="file"
                    />
                  </div>
                </>
              </div>
            )}

            {chat.file_info.type === 'video' && (
              <div
                className="flex w-full h-fit relative justify-center items-center "
                // onPointerDown={() => onHoldHandler()}
                // onPointerUp={handlePointerUp}
                // onPointerLeave={handlePointerLeave}
              >
                <button
                  type="button"
                  className="flex w-[40px] justify-center items-center absolute    z-60 h-[40px] z-[50] bg-slate-950 opacity-50 hover:opacity-100 rounded-full text-white "
                  onClick={() => {
                    playingHandler();
                    setcurrentVideoPlaying(guid);
                  }}
                >
                  <SpanIcon
                    className={classNames('p-0 m-0', {
                      'icon-namePlay-Right1': !isPlaying,
                      'icon-namepause1': isPlaying,
                    })}
                  />
                </button>

                <video
                  onPlaying={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                  onEnded={() => setIsPlaying(false)}
                  ref={vidoPlayer}
                  className="block m-0 w-100 h-100 bg-cover	min-w-full min-h-100 rounded-[8px]"
                  width="100%"
                  height="100%"
                >
                  Your browser does not support the video tag.
                  <source src={chat.file_info.url} type="video/mp4" />
                </video>
              </div>
            )}
            {chat.file_info.type === 'voice' && (
              <div
                className="flex items-center gap-1 w-full px-1"
                // onPointerDown={() => onHoldHandler()}
                // onPointerUp={handlePointerUp}
                // onPointerLeave={handlePointerLeave}
              >
                <CustomAudioPlayer
                  timer={chat.file_info.length || undefined}
                  showTime={true}
                  reseting={currentVideoPlaying !== guid ? true : false}
                  playingAction={() => setcurrentVideoPlaying(guid)}
                  theme={is_author ? 'green' : 'gray'}
                  url={chat.file_info.url}
                />
              </div>
            )}
          </>
        )}
        {text && (
          <div
            // onPointerDown={() => onHoldHandler()}
            // onPointerUp={handlePointerUp}
            // onPointerLeave={handlePointerLeave}
            className={classNames(
              'flex p-1  justify-end  text-gray-950 text-[14px] text-balance max-w-[90%]',
              {
                'break-words text-wrap	': text.length > 25,
                'text-start': !is_author,
                'text-end': is_author,
              },
            )}
          >
            {text}
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        {is_seen && is_author && (
          <div
            className={`icon-nameseen w-[14px] h-[14px] flex text-xxl text-farm-shop-500 `}
          />
        )}
        {!is_seen && is_author && (
          <div
            className={`icon-nameCheckmark w-[14px] h-[14px] flex text-xxl text-gray-700`}
          />
        )}
        {created_at && (
          <span className={`text-gray-700 text-sm font-Regular`}>
            {new Date(created_at).toLocaleString('fa-IR', {
              hour: 'numeric',
              minute: 'numeric',
            })}
          </span>
        )}
      </div>
    </div>
  );
};

export default Message;
